import { render, staticRenderFns } from "./TeachResDetail.vue?vue&type=template&id=4f3ee011&"
import script from "./TeachResDetail.vue?vue&type=script&lang=js&"
export * from "./TeachResDetail.vue?vue&type=script&lang=js&"
import style0 from "./TeachResDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TeachResDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports